module.exports = __webpack_public_path__ + "img/00009.33b25869.webp";